
import { LayoutEndpoints } from "./__db__/layout";
import { ShopEndpoints } from "./__db__/shop";

export const MockEndPoints = Mock => {
  LayoutEndpoints(Mock);
    ShopEndpoints(Mock);

  Mock.onAny().passThrough();
};